import React, { useState, useEffect } from 'react';
import HeartIcon from '../img/heart_icon.svg';
import HeartIconOn from '../img/heart_icon_on.svg';
import axios from 'axios';

export default function Heart({ pid, title }) {
  const isLikedFromStorage =
    localStorage.getItem(`liked${pid}`) === '1' ? true : false;

  const [isLiked, setIsLiked] = useState(isLikedFromStorage);

  function doLike() {
    setIsLiked(!isLiked);
  }

  useEffect(() => {
    if (!isLiked) {
      localStorage.removeItem(`liked${pid}`);
      return;
    }
    if (pid === 0) {
      return;
    }

    localStorage.setItem(`liked${pid}`, 1);
    const addNewLike = async () => {
      const result = await axios.post(
        'https://dev.perhoj.no/infinitum/panteveilederen/save.php',
        {
          id: pid,
          name: title,
        }
      );

      let results = result.data;
      console.log(results);
    };
    addNewLike();
  }, [isLiked, pid, title]);

  const likeImg = isLiked ? (
    <img src={HeartIconOn} alt='Jeg liker det!' />
  ) : (
    <img src={HeartIcon} alt='Jeg liker det!' />
  );
  return (
    <div onClick={doLike} className='mouse'>
      {likeImg}
    </div>
  );
}
